/* sg-cr26-wizard-fix */
(function(){
  function initSgCrWizard(){
    var wiz = document.getElementById('sgCrWizard');
    if(!wiz || wiz.getAttribute('data-sg-ready')==='1') return;
    wiz.setAttribute('data-sg-ready','1');
    var steps = wiz.querySelectorAll('.sg-cr26-wiz-step');
    var progEl = document.getElementById('sgCrProg');
    var prog = progEl ? progEl.children : [];
    var result = document.getElementById('sgCrResult');
    var wizStep = 0, answers = {};
    function showStep(n){
      for(var i=0;i<steps.length;i++) steps[i].classList.toggle('active', i===n);
      for(var j=0;j<prog.length;j++) prog[j].classList.toggle('on', j<=n);
    }
    function getResult(){
      var score = 0;
      if(answers.diet==='veg') score += 3;
      if(answers.diet==='low') score += 2;
      if(answers.stress==='sleep') score += 3;
      if(answers.stress==='cognitive') score += 2;
      if(answers.age==='old') score += 2;
      if(answers.age==='mid') score += 1;
      if(score >= 6) return {title:'Hohes Potenzial – Supplementierung lohnt sich',body:'Dein Profil passt zu den stärksten Effektgruppen in der Studienlage: niedrige Kreatin-Speicher und/oder chronischer Energiestress. Starte mit 5 g/Tag Monohydrat; bei Schlafmangel optional 15–20 g/Tag für 7 Tage Ladung.',study:'Basierend auf Rae 2003 (Vegetarier), McMorris 2006 (Schlafentzug), Xu 2024 (Meta-Analyse).',tag:'Empfohlen'};
      if(score >= 3) return {title:'Moderates Potenzial – Erhaltungsdosis sinnvoll',body:'Du könntest von einer konstanten Erhaltungsdosis von 3–5 g/Tag profitieren – besonders bei kognitiver Belastung. Ladephase optional.',study:'Vgl. Xu et al. 2024: Effekte bei 18–60-Jährigen signifikanter als bei >60.',tag:'Optional'};
      return {title:'Geringeres Potenzial – aber nicht ausgeschlossen',body:'Bei regelmäßiger Fleisch/Fisch-Zufuhr und wenig Stress sind deine Speicher vermutlich gut gefüllt. Kreatin kann trotzdem als günstiger Longevity-Baustein sinnvoll sein – 3 g/Tag genügt.',study:'Vgl. Kreider et al. 2017: 3 g/Tag reichen zur Erhaltung bei normaler Ernährung.',tag:'Erhaltung'};
    }
    wiz.querySelectorAll('.sg-cr26-wiz-btn[data-v]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var step = steps[wizStep];
        if(!step) return;
        step.querySelectorAll('.sg-cr26-wiz-btn').forEach(function(b){ b.classList.remove('sel'); });
        btn.classList.add('sel');
        answers[['diet','stress','age'][wizStep]] = btn.getAttribute('data-v');
        if(wizStep < 2){ wizStep++; showStep(wizStep); return; }
        var r = getResult();
        var titleEl = document.getElementById('sgCrResTitle');
        var bodyEl = document.getElementById('sgCrResBody');
        var studyEl = document.getElementById('sgCrResStudy');
        if(titleEl) titleEl.innerHTML = '<span class="sg-cr26-wiz-tag">'+r.tag+'</span> '+r.title;
        if(bodyEl) bodyEl.textContent = r.body;
        if(studyEl) studyEl.textContent = r.study;
        if(result) result.style.display = 'block';
        steps[wizStep].style.display = 'none';
      });
    });
    var reset = document.getElementById('sgCrReset');
    if(reset) reset.addEventListener('click', function(e){
      e.preventDefault();
      wizStep = 0; answers = {};
      if(result) result.style.display = 'none';
      steps.forEach(function(s){
        s.style.display = '';
        s.querySelectorAll('.sg-cr26-wiz-btn').forEach(function(b){ b.classList.remove('sel'); });
      });
      showStep(0);
    });
    showStep(0);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initSgCrWizard);
  else initSgCrWizard();
})();